import { apolloClient, onLogout } from "../../../plugins/vue-apollo";

export const signOut = () => {
  onLogout(apolloClient);
  location.reload();
};
